import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '@ui/hooks/useStore';
import MapContainer from '../Map/Map.container';
import ReportsContainer from './Reports.container';

const Container: React.FC = () => {
    const { reports } = useStore();
    const onClose = () => {
        reports.resetRows();
        reports.resetColumns();
    };
    if (reports.columns.length > 0) {
        return (
            <>
                <ReportsContainer onClose={onClose} />
            </>
        );
    } else {
        return (
            <>
                <MapContainer />
            </>
        );
    }
};

const MainContainer = observer(Container);

export default MainContainer;
